import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { ValueOf } from '../../../globalTypes';
import selectors from '../selectors';

const STATES = Object.freeze({
  EMPTY: 'EMPTY',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  UPDATING: 'UPDATING',
  UNKNOWN: 'UNKNOWN',
} as const);

type STATE_TYPES = ValueOf<typeof STATES>;

const useGetModalState = (): STATE_TYPES => {
  const { elements, isInitial, isLoading, hasError } = useSelector(selectors.presetsSelector);
  const [state, setState] = useState<STATE_TYPES>(STATES.UNKNOWN);
  const previousFinalState = useRef<STATE_TYPES>(STATES.UNKNOWN);

  useEffect(() => {
    const hasElements = elements.length !== 0;

    if (isLoading) {
      if (isInitial || !hasElements) {
        setState(STATES.LOADING);
      // don't show the update banner if the current view diplays any non-success state
      } else if (previousFinalState.current === STATES.SUCCESS) {
        setState(STATES.UPDATING);
      }
    } else if (!isInitial && hasElements) {
      setState(STATES.SUCCESS);
      previousFinalState.current = STATES.SUCCESS;
    } else if (!isInitial && !isLoading) {
      if (!hasError && !hasElements) {
        setState(STATES.EMPTY);
        previousFinalState.current = STATES.EMPTY;
      } else if (hasError) {
        setState(STATES.ERROR);
        previousFinalState.current = STATES.ERROR;
      }
    }
  }, [elements, isInitial, isLoading, hasError]);

  return state;
};

export {
  useGetModalState,
  STATES,
};
